import { toDate, weekNo } from './dateFormat';

/** ISO week-numbering year of a date (week 1 = the week with Jan 4th). */
export const isoYear = (value) => {
  const d = toDate(value);
  if (!d) return null;
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  t.setUTCDate(t.getUTCDate() + 4 - (t.getUTCDay() || 7));
  return t.getUTCFullYear();
};

export const weeksInYear = (year) => weekNo(new Date(year, 11, 28));

/** Monday of ISO week `week` in `year` as a local Date. */
export const weekStart = (year, week) => {
  const jan4 = new Date(year, 0, 4);
  const monday = new Date(jan4);
  monday.setDate(jan4.getDate() - ((jan4.getDay() || 7) - 1) + (week - 1) * 7);
  return monday;
};

export const currentWeek = () => ({ year: isoYear(new Date()), week: weekNo(new Date()) });

/** True when no filter is set or the date falls inside the selected week range. */
export const matchesWeek = (filter, value) => {
  if (!filter) return true;
  const w = weekNo(value);
  if (w == null) return false;
  return isoYear(value) === filter.year && w >= filter.from && w <= filter.to;
};

/** True when any of the dates matches (e.g. a period start / end pair). */
export const matchesWeekAny = (filter, values) => !filter || values.some((v) => matchesWeek(filter, v));

/** True when the [start, end] period overlaps the selected weeks. */
export const overlapsWeek = (filter, start, end) => {
  if (!filter) return true;
  const s = toDate(start);
  const e = toDate(end || start);
  if (!s || !e) return false;
  const fs = weekStart(filter.year, filter.from);
  const fe = weekStart(filter.year, filter.to);
  fe.setDate(fe.getDate() + 7);
  return s < fe && e >= fs;
};

export const weekLabel = (f) => (f ? `${f.year} · W${f.from}${f.to !== f.from ? `–W${f.to}` : ''}` : '');

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Week filter -> { from: 'YYYY-MM-DD' (Monday), to: 'YYYY-MM-DD' (Sunday) }. */
export const weekToRange = (f) => {
  if (!f) return { from: '', to: '' };
  const s = weekStart(f.year, f.from);
  const e = weekStart(f.year, f.to);
  e.setDate(e.getDate() + 6);
  return { from: ymd(s), to: ymd(e) };
};

/** Inverse of weekToRange: a Monday..Sunday date range maps back to its weeks. */
export const rangeToWeek = (from, to) => {
  const s = toDate(from);
  const e = toDate(to);
  if (!s || !e || s.getDay() !== 1 || e.getDay() !== 0 || isoYear(s) !== isoYear(e)) return null;
  const f = { year: isoYear(s), from: weekNo(s), to: weekNo(e) };
  return f.to >= f.from ? f : null;
};
